<script>
module.exports = require('./HCLoading.vue')
</script>
